
export const LANGUAGE_TO_COUNTRY_CODE: Record<string, string> = {
  es: 'ES',
  fr: 'FR',
  en: 'GB',
};